module.exports = "https://cdn.realtymogul.com/static/media/merlinIcons.e476a1ac.eot";